import { ResponsiveImage } from '@saulhardman/vue-responsive-image';

//
var FETCH = 'fetch';
var UPLOAD = 'upload';
var URL_TYPES = [FETCH, UPLOAD];
var SLASH = '/';
var COMMA = ',';
var TRANSFORMATION_SEPARATORS = [SLASH, COMMA];
var script = {
  name: 'VueCloudinaryImage',
  components: {
    ResponsiveImage: ResponsiveImage
  },
  inheritAttrs: false,
  props: {
    sourceUrl: {
      type: String,
      required: true
    },
    sourceWidth: {
      type: Number,
      required: true
    },
    sourceHeight: {
      type: Number,
      required: true
    },
    widths: {
      type: Array,
      required: true
    },
    cloudinaryAccount: {
      type: String,
      default: function _default() {
        if (process.env.CLOUDINARY_ACCOUNT) {
          return process.env.CLOUDINARY_ACCOUNT;
        }

        throw new Error('The `cloudinaryAccount` prop or environment variable `process.env.CLOUDINARY_ACCOUNT` must be set.');
      }
    },
    urlType: {
      type: String,
      validator: function validator(value) {
        return URL_TYPES.includes(value);
      },
      default: FETCH
    },
    srcWidth: {
      type: Number,
      default: function _default() {
        return this.widths[0];
      }
    },
    transformationSeparator: {
      type: String,
      default: '/',
      validator: function validator(value) {
        return TRANSFORMATION_SEPARATORS.includes(value);
      }
    },
    transformations: {
      type: String,
      default: function _default() {
        return ['f_auto', 'q_80'].join(this.transformationSeparator);
      }
    }
  },
  computed: {
    baseUrl: function baseUrl() {
      return "https://res.cloudinary.com/".concat(this.cloudinaryAccount, "/image/").concat(this.urlType);
    },
    aspectRatio: function aspectRatio() {
      return this.sourceWidth / this.sourceHeight;
    },
    src: function src() {
      var width = this.srcWidth;
      var height = Math.round(width / this.aspectRatio);
      return this.cloudinaryUrl(width, height);
    },
    srcset: function srcset() {
      var _this = this;

      return this.widths.filter(function (width) {
        return width <= _this.sourceWidth;
      }).map(function (width) {
        var height = Math.round(width / _this.aspectRatio);

        var source = _this.cloudinaryUrl(width, height);

        return "".concat(source, " ").concat(width, "w");
      }).join(', ');
    }
  },
  methods: {
    cloudinaryUrl: function cloudinaryUrl(width, height) {
      var sourceUrl = this.urlType === FETCH ? encodeURIComponent(this.sourceUrl) : this.sourceUrl;
      var transformations = [this.transformations, "w_".concat(width), "h_".concat(height)].filter(Boolean).join(this.transformationSeparator);
      return "".concat(this.baseUrl, "/").concat(transformations, "/").concat(sourceUrl);
    }
  }
};

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier /* server only */, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
    if (typeof shadowMode !== 'boolean') {
        createInjectorSSR = createInjector;
        createInjector = shadowMode;
        shadowMode = false;
    }
    // Vue.extend constructor export interop.
    const options = typeof script === 'function' ? script.options : script;
    // render functions
    if (template && template.render) {
        options.render = template.render;
        options.staticRenderFns = template.staticRenderFns;
        options._compiled = true;
        // functional template
        if (isFunctionalTemplate) {
            options.functional = true;
        }
    }
    // scopedId
    if (scopeId) {
        options._scopeId = scopeId;
    }
    let hook;
    if (moduleIdentifier) {
        // server build
        hook = function (context) {
            // 2.3 injection
            context =
                context || // cached call
                    (this.$vnode && this.$vnode.ssrContext) || // stateful
                    (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext); // functional
            // 2.2 with runInNewContext: true
            if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
                context = __VUE_SSR_CONTEXT__;
            }
            // inject component styles
            if (style) {
                style.call(this, createInjectorSSR(context));
            }
            // register component module identifier for async chunk inference
            if (context && context._registeredComponents) {
                context._registeredComponents.add(moduleIdentifier);
            }
        };
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        options._ssrRegister = hook;
    }
    else if (style) {
        hook = shadowMode
            ? function (context) {
                style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
            }
            : function (context) {
                style.call(this, createInjector(context));
            };
    }
    if (hook) {
        if (options.functional) {
            // register for functional component in vue file
            const originalRender = options.render;
            options.render = function renderWithStyleInjection(h, context) {
                hook.call(context);
                return originalRender(h, context);
            };
        }
        else {
            // inject component registration as beforeCreate hook
            const existing = options.beforeCreate;
            options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
    }
    return script;
}

/* script */
var __vue_script__ = script;
/* template */

var __vue_render__ = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('responsive-image', _vm._b({
    staticClass: "cloudinary-image"
  }, 'responsive-image', Object.assign({}, _vm.$attrs, {
    src: _vm.src,
    srcset: _vm.srcset
  }), false));
};

var __vue_staticRenderFns__ = [];
/* style */

var __vue_inject_styles__ = undefined;
/* scoped */

var __vue_scope_id__ = undefined;
/* module identifier */

var __vue_module_identifier__ = undefined;
/* functional template */

var __vue_is_functional_template__ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, undefined, undefined, undefined);

// Import vue component

var install = function installVueCloudinaryImage(Vue) {
  if (install.installed) {
    return;
  }

  install.installed = true;
  Vue.component('VueCloudinaryImage', __vue_component__);
}; // Create module definition for Vue.use()
// to be registered via Vue.use() as well as Vue.component()


__vue_component__.install = install; // Export component by default
// also be used as directives, etc. - eg. import { RollupDemoDirective } from 'rollup-demo';
// export const RollupDemoDirective = component;

export default __vue_component__;
